<ng-container *ngIf="uploadType === uploadTypes.File && !imageLink">
  <div class="file-upload-container">
    <app-upload-container *ngIf="!imageLink"
      [showLinkOption]="showLinkOption"
      [showHelperText]="showHelperText"
      [showLabel]="showLabel"
      [customButtonText]="customButtonText"
      [globalObjectId]="0"
      [allowedTypes]="allowedTypes"
      [maxFiles]="1"
      [showFileTypeInfo]="showFileTypeInfo"
      (onFilesAdded)="onFileAdded($event)"
      (onLinkAdded)="onAddLinkClicked()"
    ></app-upload-container>
    <ng-container *ngIf="loading">
        <div class="overlay-loader">
          <app-loading>
            <p>{{ T.common.loading | translate }}</p>
          </app-loading>
        </div>
      </ng-container>
  </div>
</ng-container>
<ng-container *ngIf="uploadType === uploadTypes.Hyperlink && !imageLink">
  <div class="link-container">
    <form [formGroup]="documentDetailsForm">
      <app-text-field
        [formGroup]="documentDetailsForm"
        [formControlName]="'link'"
        [placeholder]="T.common.link.one | translate"
        [maxLength]="255"
        [autofocus]="true"
      ></app-text-field>
    </form>
    <div class="buttons-container">
      <app-button-rectangle
        size="small"
        [text]="T.common.cancel | translate"
        [buttonTheme]="'white'"
        [disabled]="false"
        (clicked)="onLinkCancel()">
      </app-button-rectangle>
      <app-button-rectangle
        size="small"
        [text]="T.common.save | translate"
        [buttonTheme]="'primary'"
        [disabled]="!documentDetailsForm.valid"
        (clicked)="onLinkConfirm()">
      </app-button-rectangle>
    </div>
    <ng-container *ngIf="loading">
        <div class="overlay-loader">
          <app-loading>
            <p>{{ T.common.loading | translate }}</p>
          </app-loading>
        </div>
      </ng-container>
  </div>
</ng-container>

<div *ngIf="imageLink" class="image-upload-preview">
  <div class="image-preview-container"
    [ngClass]="{ rounded: false, small: true }">
      <img
        class="preview-image"
        [src]="imageLink"
        [alt]="'Preview image'"
      />
      <div class="image-overlay" (click)="removeImage()">
        <span class="material-symbols-outlined remove-icon">delete</span>
      </div>
  </div>

  <!-- Image Information -->
  <div class="image-info" *ngIf="imageFile">
    <div class="image-info-item">
      <span class="info-label">File name:</span>
      <span class="info-value" [title]="imageFile.name">{{ truncateFileName(imageFile.name, 20) }}</span>
    </div>
    <div class="image-info-item">
      <span class="info-label">File type:</span>
      <span class="info-value">{{ getFileTypeDisplay(imageFile.type) }}</span>
    </div>
    <div class="image-info-item">
      <span class="info-label">File size:</span>
      <span class="info-value">{{ formatFileSize(imageFile.size) }}</span>
    </div>
    <div class="image-info-item" *ngIf="imageDimensions">
      <span class="info-label">Dimensions:</span>
      <span class="info-value">{{ imageDimensions.width }} × {{ imageDimensions.height }} px</span>
    </div>
  </div>
</div>
